import { render, staticRenderFns } from "./detailPage.html?vue&type=template&id=59e4231b&scoped=true&external"
import script from "./detailPage.js?vue&type=script&lang=js&external"
export * from "./detailPage.js?vue&type=script&lang=js&external"
import style0 from "./detailPage.styl?vue&type=style&index=0&id=59e4231b&prod&lang=styl&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e4231b",
  null
  
)

export default component.exports